// Brand fonts, self-hosted via @fontsource: Lato (body, 400/700) + Roboto Mono
// (400/700) for phone numbers and the `Code` span. The theme references these
// families. The mono 700 is not optional: `Code` sets that weight, and without the real face the
// browser synthesizes a faux bold that smears the glyphs — worst of all on a UUID, where telling
// `0` from `O` is the whole point of setting it in mono.
import '@fontsource/lato/400.css';
import '@fontsource/lato/700.css';
import '@fontsource/roboto-mono/400.css';
import '@fontsource/roboto-mono/700.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { bootstrapFirebase } from './lib/firebase';
import { applyDocumentTitle } from './lib/marketIndicator';
import { readRuntimeConfig } from './lib/runtimeConfig';
import { App } from './App';

const bootstrap = bootstrapFirebase();
applyDocumentTitle(readRuntimeConfig());

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found in index.html');
}

createRoot(rootElement).render(
  <StrictMode>
    <App isFirebaseAvailable={bootstrap.ok} />
  </StrictMode>,
);
